import { inject } from "@angular/core";
import { Logger } from "../../../harmony/core";

export function getLogger(tag: string): Logger {
  return inject(Logger).withTag(tag);
}
